import { environment } from './environment';

export const flagsmithConfig = {
    initTimeoutMs: 1500
};

export function getFlagsmithEnvironmentKey(): string {
    const key = environment.featureFlagEnvironmentKey;

    return (!key || key.indexOf('{{') === 0) ? '' : key;
}
